import React from "react";
import { BASE_URL } from "../api";

export const Error = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <p>
        oops! Seems we can't get the needed information now, please
        <a href={`${BASE_URL}/contact-us`}> &nbsp; contact us&nbsp; </a>
        for more help.
      </p>
    </div>
  );
};
